// Static UI strings for the two supported languages
export const STRINGS = {
  en: {
    tagline: "Warm Southern hospitality, powered by AI.",
    subtag: "Meet Gentry — your 24/7 receptionist at Gens Realty.",
    startChat: "Start Chat",
    online: "Online now",
    greeting:
      "Hi there! I'm Gentry, the virtual receptionist for Gens Realty in Houston. How can I help you today?",
    placeholder: "Type a message…",
    quickHours: "Business hours",
    quickLocation: "Where are you?",
    quickServices: "Your services",
    quickMessage: "Leave a message",
    quickAppointment: "Book an appointment",
    leaveMessage: "Leave a message",
    yourName: "Your name",
    phone: "Phone number",
    reason: "How can we help?",
    submit: "Send message",
    email: "Email address (optional)",
    emailPlaceholder: "you@example.com",
    scheduleTitle: "Schedule an appointment",
    pickDate: "Pick a date",
    pickTime: "Pick a time",
    availableSlots: "Available times",
    noSlots: "No available times on this date — try another day.",
    confirm: "Confirm request",
    successMessage: "Thanks! Your message was received. Someone will reach out soon.",
    successAppointment: "Your appointment request was received. We'll confirm shortly.",
    micStart: "Speak your message",
    micStop: "Stop recording",
    listening: "Listening…",
    transcribing: "Transcribing…",
    typing: "Gentry is typing…",
    close: "Close",
    forceLang: "Language",
    auto: "Auto",
    en: "EN",
    kr: "KR",
    heroBadge: "Gens Realty · Houston, TX",
    thinking: "Thinking…",
    callUs: "Call us",
    callNow: "Call now",
    preferToCall: "Prefer to talk to a real person? Give us a call.",
    smsConsentLabel: "Yes, sign me up — text me updates about my request.",
    smsConsentBody:
      "By checking this box, I consent to receive SMS text messages from Gens Realty at the phone number I provided. Message types include appointment confirmations, follow-ups on my inquiry, and occasional listing updates I requested. Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe, HELP for help. Consent is not a condition of purchase.",
    smsConsentAcknowledged: "SMS consent captured.",
    smsConsentReviewPrefix: "See our",
    smsConsentAnd: "and",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    submitBtnSignUp: "Yes, sign me up",
    submitBtnSend: "Send message",
    submitBtnBook: "Confirm my appointment",
  },
  ht: {
    tagline: "Yon akèy cho, ak èd entèlijans atifisyèl.",
    subtag: "Rankontre Gentry — resepsyonis ou 24/7 nan Gens Realty.",
    startChat: "Kòmanse chat la",
    online: "Anliy",
    greeting:
      "Bonjou! Mwen se Gentry, resepsyonis vityèl la nan Gens Realty, Houston. Kijan m ka ede w jodi a?",
    placeholder: "Ekri yon mesaj…",
    quickHours: "Lè travay",
    quickLocation: "Kote nou ye?",
    quickServices: "Sèvis nou yo",
    quickMessage: "Kite yon mesaj",
    quickAppointment: "Pran yon randevou",
    leaveMessage: "Kite yon mesaj",
    yourName: "Kijan ou rele?",
    phone: "Nimewo telefòn ou",
    reason: "Kijan nou ka ede w?",
    submit: "Voye mesaj la",
    email: "Imèl (opsyonèl)",
    emailPlaceholder: "ou@egzanp.com",
    scheduleTitle: "Pran yon randevou",
    pickDate: "Chwazi yon dat",
    pickTime: "Chwazi yon lè",
    availableSlots: "Lè ki disponib",
    noSlots: "Pa gen lè disponib jou sa a — eseye yon lòt jou.",
    confirm: "Voye demand lan",
    successMessage: "Mèsi anpil! Nou resevwa mesaj ou. Yon moun ap rele w byento.",
    successAppointment: "Nou resevwa demand randevou ou. N ap konfime avè w byento.",
    micStart: "Pale mesaj ou",
    micStop: "Sispann anrejistre",
    listening: "N ap koute…",
    transcribing: "N ap ekri sa w di a…",
    typing: "Gentry ap ekri…",
    close: "Fèmen",
    forceLang: "Lang",
    auto: "Oto",
    en: "EN",
    kr: "KR",
    heroBadge: "Gens Realty · Houston, TX",
    thinking: "N ap reflechi…",
    callUs: "Rele nou",
    callNow: "Rele kounye a",
    preferToCall: "Ou pito pale ak yon moun? Rele nou dirèkteman.",
    smsConsentLabel: "Wi, enskri mwen — voye tèks (SMS) ban mwen sou demand mwen an.",
    smsConsentBody:
      "Lè m tcheke bwat sa a, m dakò pou m resevwa mesaj tèks (SMS) nan men Gens Realty sou nimewo telefòn mwen bay la. Kalite mesaj yo genyen konfimasyon randevou, swivi sou demand mwen, ak kèk mizajou sou pwopriyete mwen te mande. Frekans mesaj yo varye. Frè mesaj ak done ka aplike. Reponn STOP pou anile, oswa HELP pou èd. Konsantman ou pa yon kondisyon pou achte.",
    smsConsentAcknowledged: "Konsantman SMS anrejistre.",
    smsConsentReviewPrefix: "Gade",
    smsConsentAnd: "ak",
    termsOfService: "Kondisyon Sèvis",
    privacyPolicy: "Règleman Konfidansyalite",
    submitBtnSignUp: "Wi, enskri mwen",
    submitBtnSend: "Voye mesaj la",
    submitBtnBook: "Konfime randevou m",
  },
};

export function t(lang, key) {
  return (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.en[key] || key;
}
